/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["om-svg[_ngcontent-%COMP%]{margin-right:5px;vertical-align:text-bottom}  .confirmation svg path{stroke:#000}  .confirmation svg polygon{fill:#000}@media (max-width:767.98px){div.section.instructions[_ngcontent-%COMP%]{padding-left:0;padding-right:0}}"];
export { styles as styles };
